import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function ELA({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-2 -6 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M17.9671333 24.8329333S17.0938 22.8416 11.2504667 22.8416c-5.8426667 0-6.58533337 1.104-6.58533337 1.104V2.36826667S5.0438 1.1696 11.2058 1.1696c6.1626667 0 6.7613333 2.086 6.7613333 2.086v21.5773333zM31.3001333 23.9455333s-.874-1.104-6.7166666-1.104c-5.8426667 0-6.586 1.9913334-6.586 1.9913334V3.25553333s.3793333-2.086 6.5413333-2.086c6.1626667 0 6.7613333 1.19866667 6.7613333 1.19866667v21.5773333z" />
        <path d="M31.5667333 4.34073333H34.3574V26.4980667h-32.85V4.34073333h2.654" />
      </g>
    </svg>
  )
}

ELA.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
